import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { CheckoutButton } from './Button';
import { CountdownTimer } from './CountdownTimer';
const bonuses = [{
  title: '100 Ready-to-Use Dance Fitness Class Ideas™',
  description: '100 original class concepts organized by level, intensity, duration, and objective — with goals, mood, movement focus, and teaching recommendations.',
  benefit: 'Never run out of inspiration again.'
}, {
  title: '50 Complete Dance Fitness Class Plans™',
  description: '50 fully developed, ready-to-teach classes with a complete timeline, warm-up, activation, choreography, cardio peak, recovery, stretching, cues, and alternatives.',
  benefit: 'Choose a class, personalize it if you want, and teach.'
}, {
  title: '365 Warm-Ups, Cool-Downs & Movement Combinations™',
  description: 'A full year of rhythmic activations, mobility flows, footwork, upper-body patterns, cardio sequences, transitions, recovery movements, and stretches.',
  benefit: 'Create unlimited variations without repeating routines.'
}, {
  title: 'Dance Fitness Monthly Challenges™',
  description: 'Ready-to-launch 7, 14, 21, and 30-day attendance, consistency, cardio, coordination, seasonal, and community challenges with trackers and reward ideas.',
  benefit: 'Keep students motivated and coming back.'
}, {
  title: 'Professional Instructor Planner & Business Toolkit™',
  description: 'Annual, monthly, weekly, and daily planning tools; attendance and progress tracking; playlist and choreography planners; plus marketing and growth templates.',
  benefit: 'The complete organizational system for professional instructors.'
}];
export function BonusSection() {
  return <section className="border-y border-line bg-white px-4 py-20 sm:py-24" data-id="element-15">
      <div className="mx-auto max-w-5xl" data-id="element-16">
        <header className="mb-12 text-center" data-id="element-17">
          <p className="inline-flex rounded-full bg-violet-light px-3 py-1 text-xs font-bold uppercase tracking-[.18em] text-violet" data-id="element-18">
            5 exclusive bonuses
          </p>
          <h2 className="mt-4 font-display text-3xl font-bold text-navy sm:text-5xl" data-id="element-19">
            5 premium bonuses
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-slate-600" data-id="element-20">
            Exclusive resources designed to save even more time and take your
            classes to the next level.
          </p>
        </header>

        <div className="grid gap-5 md:grid-cols-2" data-id="element-21">
          {bonuses.map((bonus, index) => <motion.article key={bonus.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.06
        }} className={`relative rounded-2xl border border-violet/25 bg-white p-7 shadow-sm ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-22">
              <span className="absolute right-0 top-0 rounded-bl-xl border-b border-l border-violet/20 bg-violet-light px-3 py-1.5 text-xs font-bold text-violet" data-id="element-23">
                EXCLUSIVE BONUS {String(index + 1).padStart(2, '0')}
              </span>
              <GiftIcon className="mb-5 text-violet" size={28} data-id="element-24" />
              <h3 className="max-w-[80%] font-display text-xl font-bold text-navy" data-id="element-25">
                {bonus.title}
              </h3>
              <p className="mt-3 text-xs text-violet" data-id="element-26">
                Premium bonus <b className="ml-2" data-id="element-27">→ FREE</b>
              </p>
              <p className="mt-4 text-sm leading-relaxed text-slate-600" data-id="element-28">
                {bonus.description}
              </p>
              <p className="mt-5 text-sm font-semibold italic text-navy" data-id="element-29">
                {bonus.benefit}
              </p>
            </motion.article>)}
        </div>

        <div className="mx-auto mt-10 max-w-xl rounded-2xl border border-violet/30 bg-violet-light p-7 text-center" data-id="element-30">
          <p className="text-sm text-navy" data-id="element-31">
            All 5 bonuses are included with your purchase today
          </p>
          <p className="mt-4 text-sm text-slate-600" data-id="element-32">Your price today</p>
          <p className="mt-1 text-4xl font-bold text-violet" data-id="element-33">FREE</p>
          <p className="mt-3 text-xs text-navy-light" data-id="element-34">
            Delivered with your complete system.
          </p>
        </div>
        <CountdownTimer data-id="element-35" />
        <div className="mt-8 text-center" data-id="element-36">
          <CheckoutButton data-id="element-37">YES, I WANT MY SYSTEM NOW</CheckoutButton>
        </div>
      </div>
    </section>;
}